import { withState } from 'recompose';

export default withState('tab', 'updateTab', 'company');
